<template>
  <div class="content-panel">
    <a-input-search
      v-model="dimName"
      style="margin-bottom: 8px"
      placeholder="请选择设备"
      @search="queryDictData"
      @pressEnter="queryDictData"
    />
    <a-spin :spinning="loading" wrapperClassName="spin" class="leftBottomTree">
      <a-card :bordered="false">
        <a-tree
          style="height:calc(100% - 45px);margin-bottom: 20px;"
          v-if="treeData.length > 0"
          :defaultCheckedKeys="defaultSelectedKeys"
          :defaultExpandedKeys="defaultSelectedKeys"
          :defaultSelectedKeys="defaultSelectedKeys"
          :selectedKeys="selectedKeys"
          :treeData="treeData"
          :draggable="false"
          @expand="onExpand"
          @select="select"
          :replaceFields="{
            key: 'id',
          }"
        >
          <template slot="custom" slot-scope="item">
            <span class="treeCompanyName">{{ item.name }}</span>
          </template>
        </a-tree>
        <a-pagination
          size="small"
          show-less-items
          :current="current"
          :pageSize="pageSize"
          :total="total"
          @change="changePage"/>
      </a-card>
    </a-spin>
    <ul v-show="visible && ($auth('gasEquipmentLedger.import') || $auth('gasEquipmentLedger.export'))" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li v-if="$auth('gasEquipmentLedger.import')" @click="handleImport()">导入设备</li>
      <li v-if="$auth('gasEquipmentLedger.export')" @click="derive()">导出当前台账</li>
    </ul>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getDeviceTypeTree } from '@/api/deviceType'
import { getEquipmentTableData } from '@/api/equipmentLedger'
import { getEquipmentTree } from '@/api/gasEquipmentLedger'
export default {
  name: 'OrgTree',
  components: {
  },
  computed: {
    ...mapGetters(['centralizedManagementCompanyId'])
  },
  watch: {
    centralizedManagementCompanyId (newValue) {
      this.getAssetType()
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  data () {
    return {
      expandedKeys: [],
      loading: false,
      dimName: '',
      treeData: [],
      defaultSelectedKeys: ['000000'],
      selectedKeys: ['000000'],
      visible: false,
      top: 0,
      left: 0,
      bukrs: '',
      current: 1,
      pageSize: 10,
      total: 0,
      numberOfUpdates: 0
    }
  },
  created () {
    // 获取资产类型
    // this.getAssetType()
  },
  mounted () {
    this.$nextTick(() => {
      const dom = document.getElementsByClassName('leftBottomTree')[0]
      dom.oncontextmenu = this.openContextmenu
    })
  },
  methods: {
    ...mapActions(['handleSearchId']),
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    // 关闭右键菜单
    closeMenu () {
      this.visible = false
    },
    openContextmenu (e) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit('closeMenu', 'leftBottom')
      this.top = e.pageY - 41
      this.left = e.pageX
      this.visible = true
    },
    // 导入
    handleImport () {
      this.$emit('handleImport')
    },
    // 导出
    derive () {
      this.$emit('derive')
    },
    formateData (arr, id) {
      const f_arr = []
      const self = this
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = JSON.parse(JSON.stringify(arr[i]))
          item.key = item.code
          item.scopedSlots = { title: 'custom' }
          if (item.children && item.children.length) {
            item.children = self.formateData(item.children)
          }
          f_arr.push(item)
        }
      }
      return f_arr
    },
    // 获取资产类型
    async getAssetType (changePage) {
      this.loading = true
      if (this.centralizedManagementCompanyId.id === '空') {
        this.treeData = []
        this.loading = false
        return
      }
      const data = {
        name: this.dimName.trim(),
        subcompanyid: this.centralizedManagementCompanyId.id,
        pageSize: this.pageSize,
        pageNum: this.current,
        pid: 0,
        equipmentType: 1800000000
      }
      const res = await getEquipmentTree(data)
      if (res.status === 0) {
        this.total = res.data.total
        if (res.data.list.length > 0) {
          this.loop(res.data.list)
          this.treeData = res.data.list
          // if (this.dimName.trim()) {
          //   this.treeData = res.data
          // } else {
          //   this.treeData = [
          //     {
          //       id: '000000',
          //       scopedSlots: { title: 'custom' },
          //       name: '全部',
          //       code: '全部',
          //       children: res.data
          //     }
          //   ]
          // }
          if (!changePage) {
            this.defaultSelectedKeys = [this.dimName.trim() ? this.treeData[0].id : '000000']
            this.selectedKeys = [this.dimName.trim() ? this.treeData[0].id : '000000']
          }
        } else {
          this.treeData = []
          this.defaultSelectedKeys = []
          this.selectedKeys = []
        }
        if (!changePage) {
          this.handleSearchId({
            id: this.treeData.length > 0 ? (this.dimName.trim() ? this.treeData[0].id : '000000') : '空',
            numberOfUpdates: this.numberOfUpdates++
          })
        }
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    loop (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].scopedSlots = {
          title: 'custom'
        }
        if (data[i].children) {
          this.loop(data[i].children)
        }
      }
    },
    // 调用父组件的获取使用部门数据方法
    select (data, info) {
      this.selectedKeys = data
      if (data.length > 0) {
        // this.selectedKeys = data
        let id = ''
        if (info.selectedNodes.length === 1) {
          id = info.selectedNodes[0].data.props.id
        }
        console.log(info.selectedNodes[0].data.props)
        this.handleSearchId({
          id: id,
          numberOfUpdates: this.numberOfUpdates++
        })
      } else {
        this.handleSearchId({
          id: '000000',
          numberOfUpdates: this.numberOfUpdates++
        })
      }
    },
    // 搜索设备分类
    queryDictData () {
      this.getAssetType()
    },
    // 改变页面
    changePage (page) {
      this.current = page
      this.getAssetType(true)
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  //padding-bottom: 20px;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }
  .ant-spin-container{
    height: 100%;
    .ant-card {
      height: 100%;
      .ant-card-body {
        padding: 0;
        height: 100%;

        .ant-pagination {
          display: flex;
          justify-content: center;
          .ant-pagination-prev {
            min-width: 20px;
            height: 20px;
            line-height: 20px;
          }
          .ant-pagination-next {
            min-width: 20px;
            height: 20px;
            line-height: 20px;
          }
          .ant-pagination-jump-prev {
            height: 20px;
            line-height: 20px;
          }
          .ant-pagination-jump-next {
            height: 20px;
            line-height: 20px;
          }
          .ant-pagination-item {
            min-width: 20px;
            height: 20px;
            line-height: 20px;
          }
          .ant-pagination-item-active {
            background-color: #1791FF;
            a {
              color: white !important;
            }
          }
        }

        :global {
          .ant-tree {
            line-height: 3;

            .ant-tree-node-content-wrapper,
            .ant-tree-switcher {
              height: auto;
              margin-top: 5px;
              margin-bottom: 5px;
            }
            .ant-tree-node-content-wrapper:hover {
              background: transparent;
            }
            .ant-tree-treenode-selected {
              background: #e6f7ff;
              height: auto !important;
              .ant-tree-node-selected {
                background: transparent;
              }
            }

            .ant-tree-child-tree {
              background: #fff;
            }
            li {
              position: relative;
              line-height: 3;
              padding-bottom: 0;
            }
          }
          .ant-btn {
            margin-bottom: 8px;
          }
        }

        .icon-panel {

          .anticon-plus,
          .anticon-setting,
          .anticon-edit,
          .anticon-delete {
            margin-left: 5px;
            color: #1890ff;
          }
        }
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.spin {
  height: calc(100% - 40px);
  overflow: auto;
}
.treeCompanyName {
  font-size: 14px;
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  width: 120px;
  text-align: center;
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: rgba(231, 244, 255, 1);
}
</style>
